import TitleCover from "components/shared/TitleCover";
import type { IWorkTitleSummary } from "containers/Works/types";
import type { HTMLAttributes } from "react";
import { useTranslation } from "react-i18next";

import { titleSubtitle } from "./titleDisplay";

type CoveredTitlesOptionProps = {
    option: IWorkTitleSummary;
    listProps: HTMLAttributes<HTMLLIElement>;
};

const CoveredTitlesOption = ({ option, listProps }: CoveredTitlesOptionProps) => {
    const [t] = useTranslation();
    const subtitle = titleSubtitle(option, t("Works.Ean13"));

    return (
        <li {...listProps} key={option.id}>
            <span className="covered-titles-option">
                <span className="covered-titles-option-cover">
                    <TitleCover coverUrl={option.avatarUrl ?? undefined} title={option.name} color="title-color" />
                </span>
                <span className="covered-titles-chip-text">
                    <span className="covered-titles-chip-name">{option.name}</span>
                    {subtitle ? <span className="covered-titles-chip-meta">{subtitle}</span> : null}
                </span>
            </span>
        </li>
    );
};

export default CoveredTitlesOption;
